/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Interest_Consumer_BrandsInputs */

const en_onboarding_v1_interest_consumer_brands = /** @type {(inputs: Onboarding_V1_Interest_Consumer_BrandsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consumer Brands`)
};

const de_onboarding_v1_interest_consumer_brands = /** @type {(inputs: Onboarding_V1_Interest_Consumer_BrandsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbrauchermarken`)
};

const pt_br2_onboarding_v1_interest_consumer_brands = /** @type {(inputs: Onboarding_V1_Interest_Consumer_BrandsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcas de consumo`)
};

const tr_onboarding_v1_interest_consumer_brands = /** @type {(inputs: Onboarding_V1_Interest_Consumer_BrandsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüketici markaları`)
};

const zh_cn2_onboarding_v1_interest_consumer_brands = /** @type {(inputs: Onboarding_V1_Interest_Consumer_BrandsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消费品牌`)
};

const zh_hk2_onboarding_v1_interest_consumer_brands = /** @type {(inputs: Onboarding_V1_Interest_Consumer_BrandsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消費品牌`)
};

const ko_kr2_onboarding_v1_interest_consumer_brands = /** @type {(inputs: Onboarding_V1_Interest_Consumer_BrandsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`소비재 브랜드`)
};

const ru_ru2_onboarding_v1_interest_consumer_brands = /** @type {(inputs: Onboarding_V1_Interest_Consumer_BrandsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Потребительские бренды`)
};

const es_419_onboarding_v1_interest_consumer_brands = /** @type {(inputs: Onboarding_V1_Interest_Consumer_BrandsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcas de consumo`)
};

/**
* | output |
* | --- |
* | "Consumer Brands" |
*
* @param {Onboarding_V1_Interest_Consumer_BrandsInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_interest_consumer_brands = /** @type {((inputs?: Onboarding_V1_Interest_Consumer_BrandsInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Interest_Consumer_BrandsInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_interest_consumer_brands(inputs)
	if (locale === "de") return de_onboarding_v1_interest_consumer_brands(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_interest_consumer_brands(inputs)
	if (locale === "tr") return tr_onboarding_v1_interest_consumer_brands(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_interest_consumer_brands(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_interest_consumer_brands(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_interest_consumer_brands(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_interest_consumer_brands(inputs)
	return es_419_onboarding_v1_interest_consumer_brands(inputs)
});